import React from 'react';
import classNames from 'classnames';
import './MarketingPromoCard.pcss';
import nailImg from './nail-promo-bg.jpg';
import larryImg from './larry-promo-bg.jpg';

type ContetMap = {
  [key: number]: {
    src: string;
    title?: string;
    body: string;
    name: string;
    position: string;
  };
};

type Props = {
  className?: string;
  step: number;
  contentMapOverride?: ContetMap;
};

const contentMap: ContetMap = {
  1: {
    src: nailImg,
    title: 'Connect with your future customers...',
    body:
      'For some reason, not very many marketers are taking advantage of\n' +
      'Messanger marketing, even though it’s the hottest opportunity in\n' +
      'digital marketing today.',
    name: 'Neil Patel',
    position: 'Forbes Top 10 Marketer',
  },
  2: {
    src: larryImg,
    title: '...On the messaging platform they already use.',
    body:
      'Marketers can use Customers.ai to connect with customers on the most\n' +
      'popular mobile chat application in the U.S., Facebook Messenger, used by over a billion people every day.',
    name: 'Larry Kim',
    position: 'CEO & Co-founder, Customers.ai',
  },
};

export const MarketingPromoCard = ({
  className,
  step = 1,
  contentMapOverride,
}: Props) => {
  const content = (contentMapOverride || contentMap)[step];
  if (!content) {
    return null;
  }

  const { title, position, src, body, name } = content;

  return (
    <div
      className={classNames(className, 'mpc')}
      style={{ backgroundImage: `url('${src}')` }}
    >
      <div className="mpc_content">
        {title && <span className="mpc_title">{title}</span>}
        <div className="mpc_quote">
          <span className="mpc_quote-mark">“</span>
          <span className="mpc_quote-text">{body}</span>
        </div>

        <span className="mpc_name">{name}</span>
        <span className="mpc_position">{position}</span>
      </div>
    </div>
  );
};
